import { memo } from 'react';

const objectDeepCompare = require('object-deep-compare');

const deepCompare = (a, b) => a && b && objectDeepCompare.CompareValuesWithConflicts(a, b).length === 0;

export const withMemo = (Component, checkedProps) => {
    function areEqual(prevProps, nextProps) {
        let isEqual = true;
        for (let i = 0; i < checkedProps.length; i += 1) {
            const checkedProp = checkedProps[i];
            if (!deepCompare(prevProps[checkedProp], nextProps[checkedProp])) {
                isEqual = false;
                break;
            }
        }
        console.log('withMemo returns', isEqual);
        return isEqual;
    }

    return memo(Component, areEqual);
};
